import { createColumnHelper } from "@tanstack/react-table";
import { Checkbox } from "@mui/material";

const columnHelper = createColumnHelper<any>();

export const PaymentHistoryColumns = (
  openReceiptModal: (data: any) => void,
) => [
  columnHelper.accessor("sn", {
    header: "SN",
    cell: ({ row }) => (
      <Checkbox
        color="success"
        checked={row.getIsSelected()}
        onChange={row.getToggleSelectedHandler()}
        sx={{
          color: "#E0E0E0",
          "&.Mui-checked": {
            color: "#00B074",
          },
        }}
      />
    ),
  }),
  columnHelper.accessor("date", {
    header: "Date",
    cell: (info) => <span className="text-[#464255]">{info.getValue()}</span>,
  }),
  columnHelper.accessor("amount", {
    header: "Amount",
    cell: (info) => (
      <span className="text-[#464255] font-medium">{info.getValue()}</span>
    ),
  }),
  columnHelper.accessor("status", {
    header: "Status",
    cell: (info) => {
      const status = info.getValue();
      let color = "#464255";
      if (status === "Paid") color = "#00B074";
      else if (status === "Pending") color = "#D97706";
      else if (status === "Failed") color = "#B42318";

      return (
        <span style={{ color }} className="font-medium">
          {status}
        </span>
      );
    },
  }),
  columnHelper.accessor("description", {
    header: "Description",
    cell: (info) => (
      <span className="text-[#464255] max-w-[300px] truncate block">
        {info.getValue()}
      </span>
    ),
  }),
  columnHelper.accessor("payment", {
    header: "Payment",
    cell: ({ row }) => (
      <button
        onClick={() => openReceiptModal(row.original)}
        className="px-4 py-1.5 rounded-full border border-[#00B074] text-[#00B074] text-xs font-bold uppercase hover:bg-[#E6F7F1] transition-colors"
      >
        VIEW Receipt
      </button>
    ),
  }),
];
